import type { SVGProps } from 'react';
export const AsTyped = (props: SVGProps<SVGSVGElement>) => (
  <svg width="1rem" height="1rem" fill="currentColor" viewBox="0 0 20 20" {...props}>
    <path
      fillRule="evenodd"
      d="M7.29 5.5c.27 0 .51.15.62.38l3.61 7.72c.15.32 0 .7-.34.84a.7.7 0 0 1-.9-.32l-.81-1.74-.17.02H5.28l-.17-.02-.81 1.74a.7.7 0 0 1-.9.32.63.63 0 0 1-.34-.84l3.61-7.72c.11-.23.35-.38.62-.38m-1.58 5.61h3.17L7.29 7.73zm8.6-1.49a1 1 0 0 0-.3.16.7.7 0 0 1-.96-.06.6.6 0 0 1 .06-.9c.6-.5 1.21-.51 1.63-.51q1.1 0 1.72.68c.4.44.54 1 .54 1.52v3.35c0 .35-.3.64-.68.64a.7.7 0 0 1-.63-.4q-.59.39-1.34.4c-1.2 0-2.26-.88-2.26-2.05s1.05-2.04 2.26-2.04q.72.01 1.3.37v-.27q-.02-.48-.22-.68c-.1-.12-.3-.24-.69-.24q-.28 0-.43.03m.04 2.07c-.55 0-.9.38-.9.76s.35.76.9.76c.54 0 .9-.38.9-.76s-.36-.76-.9-.76"
      clipRule="evenodd"
    />
  </svg>
);
